import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Table from "../../../../components/reusable-table/Table";
import Breadcrumb from "../../../../components/custom-breadcrumb/Breadcrumb";
import { useAppDispatch, useAppSelector } from "../../../../redux/store/hooks";
import { fetchUserFeedback } from "../../../../redux/slices/userListSlice";
import { formatDateTime } from "../../../../utils/formatDateTime";

const columns = [
  { header: "Feedback", accessor: "feedback" },
  { header: "Created By", accessor: "createdBy" },
];

const UserFeedback: React.FC = () => {
  const { userId, name } = useParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const { feedbackList, feedbackLoading } = useAppSelector(
    (state) => state.userList,
  );

  /* ================================
     Fetch Feedback
  ================================= */
  useEffect(() => {
    if (userId) {
      dispatch(
        fetchUserFeedback({
          userId,
          pageId: 1,
          limit: 10,
        }),
      );
    }
  }, [dispatch, userId]);

  /* ================================
     Breadcrumb
  ================================= */
  const breadcrumbItems = [
    { label: "Users", onClick: () => navigate("/users") },
    { label: name ?? "", onClick: () => navigate(`/users/${name}/${userId}`) },
    { label: "Feedback", disabled: true },
  ];

  /* ================================
     Format Data For Table
  ================================= */
  const formattedData = feedbackList.map((item) => ({
    feedback: item.feedback,
    createdBy: (
      <div className="merged-cell">
        <div className="merged-label">{item.creator?.name ?? "-"}</div>
        <div className="merged-date">{formatDateTime(item.createdAt)}</div>
      </div>
    ),
  }));

  return (
    <div>
      <Breadcrumb items={breadcrumbItems} />

      <h1
        style={{
          color: "#4C4C4C",
          fontSize: "32px",
          fontWeight: 700,
          letterSpacing: "-0.114px",
        }}
      >
        Feedback
      </h1>

      <Table
        columns={columns}
        data={formattedData}
        rowsPerPage={20}
        rounded
        loading={feedbackLoading}
      />
    </div>
  );
};

export default UserFeedback;
